import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ImageResult } from 'ngx-image2dataurl';
import { AppSettings } from '../../../app.settings';
import { LocalStorage, LocalStorageService} from 'ngx-store';
import { ToastrService } from 'ngx-toastr';
import  *  as  helpData  from  '../../../data/help/superadminaccounts.json';
import { Router } from '@angular/router';

//Model
import { Url } from '../../../model/users.model';
import { User } from '../../../model/users.model';

//Service
import { MenuService } from '../../../theme/components/menu/menu.service';
import { DataService } from '../../../services/data.service';
import { UsersService } from '../../../services/users.service';
import { FilesService } from '../../../services/files.service';
import { ComponentsSettingsService } from '../../../services/components_settings.service';

class FileUpload {
  file: any;
  folder: string;
}

@Component({
  selector: 'app-superadminaccounts',
  templateUrl: './superadminaccounts.component.html',
  styleUrls: ['./superadminaccounts.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MenuService, UsersService, FilesService, LocalStorageService, ComponentsSettingsService]
})
export class SuperAdminAccountsComponent implements OnInit {
    @LocalStorage() url: Url;
  
    results: any;
    public members: User[];
    public subroles: any[];
    public member: User;
    public searchText: string;
    public type:string = 'grid';
    public modalRef: NgbModalRef;
    public form1:FormGroup;
    public addForm: FormGroup;
    public p:any;
    folderPath: string;
    public menuItems:Array<any>;  
    public menuSelectOptions: IMultiSelectOption[] = [];
    public menuSelectSettings: IMultiSelectSettings = {
        enableSearch: true,
        checkedStyle: 'fontawesome',
        buttonClasses: 'btn btn-secondary btn-block',
        dynamicTitleMaxItems: 0,
        displayAllSelectedText: true,
        showCheckAll: true,
        showUncheckAll: true
    };
 
    public menuSelectTexts: IMultiSelectTexts = {
        checkAll: 'Select all',
        uncheckAll: 'Unselect all',
        checked: 'menu item selected',
        checkedPlural: 'menu items selected',
        searchPlaceholder: 'Find menu item...',
        defaultTitle: 'Select menu items for user',
        allSelected: 'All selected',
    };

  
    public genFilename :string;
    public file: string;

    public picExists :boolean;
    public picRemove :boolean;
    public oldpic: string;
    help: any;
    memberDelete: any;
    loadingIndicator: boolean = true;

    fileUpload = new FileUpload();
    
    public frmPassword:FormGroup;
    public passwordNew : FormControl;
    public confirmPassword: FormControl;
    spinner: boolean = false;
    selected = [];

    current_user_id : number;

    @ViewChild('modalDeleteSuperAdmin', {static: false}) modalDeleteSuperAdmin: TemplateRef<any>;

    constructor(private http: HttpClient, 
                public menuService:MenuService,
                public modalService: NgbModal,
                private fb : FormBuilder,
                private fb2 : FormBuilder,
                private memberService : UsersService,
                public appSettings: AppSettings,
                private fileService : FilesService,
                private toastr: ToastrService,
                private data: DataService,
                private svc_storage: LocalStorageService,
                public router:Router,
                public svc_component :ComponentsSettingsService) { 
        
        this.menuItems = this.menuService.vertical_menu_items;
        this.menuItems.forEach(item=>{
            let menu = { 
            id: item.id, 
            name: item.title
            }
            this.menuSelectOptions.push(menu);
        });
        this.picExists = false;
        this.picRemove = false;
        this.oldpic = '';
        this.file = '';
    }
 

    ngOnInit() {
        this.current_user_id = this.svc_storage.get('user').id;
        this.getMembers();

        this.folderPath = this.url.fileStorage + '/users';
        this.data.currentHelp.subscribe(help => this.help = help);   
    }

	ngAfterViewInit() {
		setTimeout(() => { 	this.data.changeHelp(helpData["default"]);  });
	}
  
    public getMembers (){
        this.initializeForms();
        this.memberService.getSuperAdminAccounts().subscribe(data => {
            this.members = data["members"];

            this.selected = this.members
            this.subroles = data['subroles'];
            
            setTimeout(() => { this.loadingIndicator = false; });
            
        });
    }

    public initializeForms(){
        const email = "^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,12}$";

        this.form1 = this.fb.group({
            id:null,
            display_name: [null, Validators.compose([Validators.required, Validators.minLength(5)])],
            username: [null, Validators.compose([Validators.required, Validators.minLength(5)])],
            email: [null, Validators.compose([Validators.required, Validators.pattern(email)])],
            joined: '',
            password: null,
            status: '1',
            role_id: this.svc_component.sar_id,
            subrole_id: null,
            avatar: 'nopic.png',
            signature_file: 'nopic.png',
            reminder: null,
            remember: '0',
            updated_by: this.current_user_id
        });

        this.addForm= this.fb.group({
        display_name: [null, Validators.compose([Validators.required, Validators.minLength(5)])],
        username: [null, Validators.compose([Validators.required, Validators.minLength(5)])],
        email: [null, Validators.compose([Validators.required, Validators.pattern(email)])],
        confirm_password: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
        password  : ['',Validators.compose([Validators.required, Validators.minLength(4)])],      
        subrole_id: [null],
        avatar: ['nopic.png'],
        created_by: this.current_user_id
        },{ validator: this.checkaddPasswords });
        
        this.frmPassword = this.fb2.group({
            id        : null,
            password    : '',
            old_password  : '',
            confirm_password: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
            new_password  : ['',Validators.required,],
            updated_by: this.current_user_id
        },{ validator: this.checkPasswords });
    }

    checkPasswords(group: FormGroup) { 
        let pass = group.controls.confirm_password.value;
        let confirmPass = group.controls.new_password.value;
        return pass === confirmPass ? null : { notSame: true }
    }

    checkaddPasswords(group: FormGroup) {
        let pass = group.controls.confirm_password.value;
        let confirmPass = group.controls.password.value;
        return pass === confirmPass ? null : { notSame: true }
    }

    public toggle(type){
        this.type = type;
    }

    async createMember(member:User) {
        this.spinner = true;
        await  this.memberService.createSuperAdminAccount(member).toPromise().then(member => {
            this.toastr.success('', member["message"], {
            timeOut: 4000,
            positionClass: 'toast-top-full-width',
            progressBar: true
            });
            this.getMembers();   
        }, error =>{
            this.toastr.error("Please try again.", "There was a problem with deleting the selected user", {
            timeOut: 4000,
            positionClass: 'toast-top-full-width',
            progressBar: true
            });
        });
        this.spinner = false;
    }


    async updateMember(member:User) {
        this.spinner = true;
        await this.memberService.updateMember(member).toPromise().then(member => {
        this.toastr.success('', member["message"], {
            timeOut: 4000,
            positionClass: 'toast-top-full-width',
            progressBar: true
        });
        this.getMembers();  
        this.initializeForms();    
        }, error =>{
        this.toastr.error("Please try again.", "There was a problem updating the selected user record", {
            timeOut: 4000,
            positionClass: 'toast-top-full-width',
            progressBar: true
        });
        });
        console.log('UPDATED ACCOUNT');
        this.spinner = false;
    }

    openDeleteAdminModal(member: User){
        console.log("DELETING ACCOUNT")
        this.memberDelete = member;
        this.modalRef = this.modalService.open(this.modalDeleteSuperAdmin, { size: 'sm', backdrop: 'static' });
    }

  async deleteMember(){
     this.spinner = true;
     await this.memberService.deleteMember(this.memberDelete.id).toPromise().then(result => {
      this.toastr.success('', result["message"], {
        timeOut: 4000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
      this.getMembers();
      this.initializeForms();
    },error =>{
      this.toastr.error("Please try again.", "There was a problem deleting the selected user", {
        timeOut: 4000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    console.log('DELETED ACOUNT');
    this.closeModal();
    this.spinner = false;
  }

    public openModal(modalContent, member) {
        if(member){
        	this.picExists = false;
            this.member = member;
            this.form1.patchValue(this.member);
                    
            if (member.avatar != 'nopic.png' && member.avatar != '' && member.avatar != null){
                this.picExists = true;
                this.oldpic = member.avatar;
            }
        }else{
            this.member = new User();
            this.form1.controls.avatar.setValue('nopic.png');
        };

        this.modalRef = this.modalService.open(modalContent, { container: '.app', backdrop: 'static' });
        
        this.modalRef.result.then((result) => {
        this.form1.reset();
        }, (reason) => {
        this.form1.reset();
        });
    }

    public openAddModal(modalContent) {
        this.member = new User();

        this.modalRef = this.modalService.open(modalContent, { container: '.app', backdrop: 'static' });
   
        this.modalRef.result.then((result) => {
            this.addForm.reset();
        }, (reason) => {
            this.addForm.reset();
        });

        this.addForm.controls.subrole_id.setValue('9');
        this.picExists = false;
    }

    public closeModal(){
        this.modalRef.close();
    }

    public onSubmit(member:User):void {
        this.spinner = true;
        member.updated_by = this.current_user_id;
        this.checkUniqueUsername('update');
        if(this.is_unique){
            if (this.form1.valid) {
                this.member = member;
                
                if(this.file != ''){
                    this.createFile(member, 'form1');
                }else{
                    if(member.id){
                        this.updateMember(this.member);
                    }
                    else{
                        this.createMember(this.member);
                    }   
                }
        
                //handling image
                if(this.picRemove == true){
                    this.fileService.deleteFile('users', this.oldpic).subscribe(result=>{})
                    
                    //resets value of file variables as the form is in modal view
                    this.picRemove = false;
                    this.file ='';
                    this.oldpic = '';
                    this.picExists = false;
                };
                this.closeModal();    
            }
        };
        
    }
    
    public onSubmitAddForm(member:User):void {
        member.created_by = this.current_user_id;
        if (this.addForm.valid) {
            this.member = member;
            
            if(this.file != ''){
                this.createFile(member, 'addform');
            }else{
                this.createMember(this.member);
            }
            this.closeModal();    
        }    
    }

 
    public createFile(member : User, caller)
    {
        this.fileUpload.file = this.file;
        this.fileUpload.folder = 'users';
        console.log('=========');
        this.fileService.uploadImageFile('users',this.file).subscribe(file =>{
            if(caller == 'form1'){
                this.form1.controls.avatar.setValue(file['data']);
            }else{
                this.addForm.controls.avatar.setValue(file['data']);
            }
            
            this.member.avatar = file['data'];
            
            if(member.id){
                this.updateMember(this.member);
            }
            else{
                this.createMember(this.member);
            }   
        } );
    }

    public getFile(event, form){
        var pictureFile : ImageResult;
        pictureFile = event;

        this.file = event;
        form.controls.avatar.setValue(pictureFile.file.name);
        form.markAsDirty();
    }

    public removePic(){
        this.picExists  = false;
        this.form1.controls.avatar.setValue('nopic.png');
        this.form1.markAsDirty();
        this.picRemove = true;
        this.file ='';
    }

    public openModalChangePassword(modalPassword, id) {
        this.modalRef = this.modalService.open(modalPassword, { container: '.app', backdrop: 'static' });
        
        this.modalRef.result.then((result) => {
        
        this.frmPassword.reset();
        }, (reason) => {
            this.frmPassword.reset();
        });
        this.frmPassword.controls.id.setValue(id);
    }

    async updatePassword(password:any) {
        password.updated_by = this.current_user_id;
        this.spinner = true;
        await this.memberService.updatePasswordOfOthers(password).toPromise().then(member => {
            this.getMembers();  
            this.closeModal();
            if(member){
                this.toastr.success('', 'Password ' + member["message"], {
                    timeOut: 5000,
                    positionClass: 'toast-top-full-width',
                    progressBar: true
                });
            }
        
        }).catch(err =>{
            this.toastr.error("Please try again.", "There was a problem with updating admin password", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
            });
        });
        this.initializeForms();
        this.spinner = false;
    }

    public user: User;
    public changeStatus(modalStatus, user:User) {
        this.user = user;
        //console.log("USER",this.user);
        this.modalRef = this.modalService.open(modalStatus, { container: '.app', backdrop: 'static' });
    }

    async editMemberStatus(id:number, value:number){
        this.spinner=true;
        await this.memberService.updateMemberStatus(id, value).toPromise().then(result => {
                this.toastr.success('', result["message"], {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
            });
            
            }).catch(err =>{
                this.toastr.error("Please try again.", "There was a problem with updating the selected status of user", {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
            });
        });

        //check if the admin user deactivated his own account, if yes trigger user logout
        if(value ==0  && this.current_user_id == id){
            this.toastr.success("User logout", "The current user has been deactivated.", {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
            });
            this.router.navigate(['logout']);
        }

        this.getMembers();
        this.closeModal();
        this.spinner=false;
    }

    public is_unique :boolean = true;
    public checkUniqueUsername(caller){
        this.is_unique = true;
        var current_login = '';
        if(caller=='add'){
            current_login = this.addForm.controls.username.value;
        }else{
            current_login = this.form1.controls.username.value;
        }; 
        
        if(( caller == 'update' && current_login != this.member.username) || caller=='add'){
            this.memberService.checkUniqueLogin(current_login).subscribe(data=>{
                if(data['user'].length > 0){
                    this.is_unique = false;
                    if(caller == 'add'){
                        this.addForm.controls.username.setErrors({notUnique:false});this.addForm.updateValueAndValidity();
                    }else{
                        this.form1.controls.username.setErrors({notUnique:false});this.addForm.updateValueAndValidity();
                    };
                }else{
                    this.is_unique = true;
                };
            });
        }
    }

}  